app.service('listGroup',function($global){

	function render($parentListBox) {

		function reindexListInputsNames() {

			console.log('reindexListInputsNames');
			var $listItems = $parentListBox.find('.list-element');
			if ($listItems.length) {
				$listItems.each((index, listItem) => {
						var $inputs = $(listItem).find('input, select');
						if ($inputs.length) {
							$inputs.each((index2, input) => {
								var $thisInput = $(input);
								var newName = $thisInput.attr('name').replace( /(\d+)/, index );
								$thisInput.attr('name', newName);
							});
						}
					}
				);
				$parentListBox.find('.list-template').find('input').each((index, input) => {
					var $thisInput = $(input);
					var newName = $thisInput.attr('name').replace( /(\d+)/, $listItems.length );
					$thisInput.attr('name', newName);
				});
			}
		}
		
		function addListRow(){
			console.log('addListRow');
			var $newElement = $parentListBox.find('.list-template').clone();
		
			$newElement.removeClass('list-template hidden').addClass('list-element');
			$newElement.find('input, select').attr('value','').prop('disabled', false);
		
			$newElement.insertBefore($parentListBox.find('.list-group-bottom-actions'));
			reindexListInputsNames($parentListBox);
		}

		function removeListRow(buttonRemove) {
			$(buttonRemove).closest('.list-element').remove();
			reindexListInputsNames();
		}

		function moveUpListRow(element){
			console.log('moveUpListRow');

			var $thisParentRow = $(element).closest('.list-element');
			var $previousRow = $thisParentRow.prev('.list-element');

			console.log($thisParentRow);
			console.log($previousRow);

			if ($previousRow.length) {
				$thisParentRow.insertBefore($previousRow);
                reindexListInputsNames();
			}
		}

		function moveDownListRow(element){
			console.log('moveDownListRow');

			var $thisParentRow = $(element).closest('.list-element');
			var $nextRow = $thisParentRow.next('.list-element');

			console.log($thisParentRow);
			console.log($nextRow);

			if ($nextRow.length) {
				$thisParentRow.insertAfter($nextRow);
				reindexListInputsNames();
			}
		}

		$parentListBox.on('click', '.js-add-list-row', function(event) {
			event.preventDefault();
			addListRow();
		}).on('click', '.js-remove-list-row', function(event) {
			event.preventDefault();
			removeListRow(this);
		}).on('click', '.js-move-up-list-row', function(event) {
			event.preventDefault();
			moveUpListRow(this);
		}).on('click', '.js-move-down-list-row', function(event) {
			event.preventDefault();
			moveDownListRow(this);
		});
	}
	function init(){
		if($('.simple-list-group .list-box').length) {
			$('.list-box').each(function() {
				render($(this));
			});
		}
	}

	$global('listGroupInit', init);
	return {
		init
	}
});
